module.exports = __webpack_public_path__ + "img/amex.6bc186e7.png";